import { Navigate } from 'react-router'
import { PERMISSION_ACTION_VIEW, PERMISSION_ENTITY_TREASURY, ROUTE_KLEAR_ACCOUNT, ROUTE_ORDERS } from '@klear/constants'
import { useAuth } from '@klear/ui/contexts/auth-context'

export default function TraderLanding() {
  const { user } = useAuth()
  const canSeeKlearAccount = user.hasPermission(PERMISSION_ENTITY_TREASURY, PERMISSION_ACTION_VIEW)

  return <Navigate to={canSeeKlearAccount ? ROUTE_KLEAR_ACCOUNT : ROUTE_ORDERS} replace />
}
